import React from 'react';

import IconButton from '@cineamo/ui/src/button/IconButton';
import { IconCloseSolid24 } from '@cineamo/ui/src/icons/ic-closeSolid';

const AdvertisementCloseButton: React.FC<{ className?: string; onClose?: () => void }> = ({ className, onClose }) => {
    return (
        <IconButton
            icon={IconCloseSolid24}
            classNameIcon="relative text-white bg-black rounded-4"
            accessibilityLabel="Close advertisement"
            onClick={onClose}
            classNameButton={className}
        />
    );
};

export default AdvertisementCloseButton;
